import React from 'react';
import { useTranslate } from '@federico.moretti/react-translate';
import styled from 'styled-components/macro';
import { Card } from '../../atoms';
import DetailsList from '../DetailsList';
import { ActionText } from '../../typography';
import { SPACINGS } from '../../utils';

const ActionWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: ${SPACINGS[6]};
`;
const cardStyle = { position: 'relative' as const };

type UserContactsProps = {
  email: string;
  phone: string | number;
  preferred?: 'email' | 'phone';
  enableMailTo?: boolean;
  action?: React.ReactNode;
};
function UserContacts(props: UserContactsProps) {
  const { email, phone, preferred, enableMailTo, action } = props;
  const { t } = useTranslate();

  const emailComponent = React.useMemo(
    () =>
      enableMailTo ? (
        <ActionText
          margin="none"
          type="link-external"
          transform="none"
          target="_blank"
          to={`mailto:${email}`}
        >
          {email}
        </ActionText>
      ) : (
        email
      ),
    [email, enableMailTo]
  );

  const items = React.useMemo(
    () => [
      {
        label: t('email'),
        value: emailComponent,
        favorite: preferred === 'email',
      },
      {
        label: t('phone'),
        value: phone,
        favorite: preferred === 'phone',
      },
    ],
    [phone, preferred, emailComponent, t]
  );

  return (
    <Card style={cardStyle}>
      {action && <ActionWrapper>{action}</ActionWrapper>}
      <DetailsList items={items} />
    </Card>
  );
}

export default UserContacts;
